/* eslint-disable react/prop-types */
import { FormHelperText, Grid, Typography } from "@mui/material";

const CustomInput = ({ label, input, required, textSx = {}, helperText,textAlign ,helperColor }) => (
    <Grid container spacing={.5}>
        
        <Grid item xs={12}>
            <Typography variant='subtitle2' sx={{ display: "flex", marginBottom: "2px", ...textSx }}>{label}  {required && <Typography variant="subtitle2" color='error'>*</Typography>}</Typography>
        </Grid>
        <Grid item xs={12}>
            {input}
            {helperText && <FormHelperText sx={{ fontSize: "14px", fontWeight: 400, textAlign: textAlign || "start", color: helperColor || '' }}>{helperText}</FormHelperText>}
        </Grid>
    </Grid>
);

export default CustomInput